const countryList = require('country-list');
const _ = require('lodash');

const defaultState = {
  countries: [],
};

const getters = {
  getCountries: state => state.countries,
};

const actions = {
  loadCountries: async (context) => {
    context.commit('setCountries', countryList.getData());
  },
  getUserIpAddress: async () => {
    const response = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
    const rawText = await response.text();
    // split by new line and then by = to get the value
    const data = _.fromPairs(rawText.split('\n').map(line => line.split('=')));
    return data.ip;
  },
};

const mutations = {
  setCountries: (state, countries) => {
    state.countries = countries;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
